import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';

const TrafficTotalContext = createContext(null);

export function SwItsIndicatortsDataProvider({ children }) {
    const [currentData, setCurrentData] = React.useState();

    React.useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("dashboard/bis/GetThreeIndicatorsData");
            if (response.status === 200) {
                const data = response.data;
                setCurrentData({
                    updateTime: data.updateTime,
                    rows: data.rows.map(row => {
                        if (row.calType === "정확도") {
                            return {
                                ...row,
                                displayBaseValue: `± 3 분`,
                                displayValue: String(row.calValue / 100)[0] == 0
                                    ? `± ${String(row.calValue)[0]}${String(row.calValue)[1]}초`
                                    : `± ${String(row.calValue)[0]}분${String(row.calValue)[1]}${String(row.calValue)[2]}초`
                            };
                        } else {
                            return {
                                ...row,
                                unit: '%',
                                displayBaseValue: `${row.baseValue.toFixed(0)}`,
                                displayValue: `${row.calValue}`
                            };
                        }
                    })
                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}


export function SwItsIndicatortsDataInfo() {
    const currentData = useContext(TrafficTotalContext);

    if (!currentData || !Array.isArray(currentData.rows)) return null;

    const rows = currentData.rows;

    const updateTime = rows[0]?.updateTime ?? '';
    const month = updateTime ? new Date(updateTime).getMonth() + 1 : null; 

    return (
        <div className="grid">
            <div className="box1">구분</div>
            <div className="box2">BIS 정확도</div>
            <div className="box3">BIS 검출률</div>
            <div className="box4">BIS 통신율</div>
            <div className="box5">
                국토교통부<br />성능지표기준
            </div>

            {rows.map((row) => {
                if (row.calType === '정확도') {
                    const [min, sec] = row.displayValue.match(/\d+/g) || [];
                    const baseParts = row.displayBaseValue.match(/\d+/g) || [];
                    const baseSeconds = (parseInt(baseParts[0]) || 0) * 60 + (parseInt(baseParts[1]) || 0);
                    const calSeconds = (parseInt(min) || 0) * 60 + (parseInt(sec) || 0);
                    
                    const isGood = calSeconds <= baseSeconds;
                    const colorStyle = { color: isGood ? 'var(--iv-05)' : 'var(--iv-02)' };

                    return (
                        <>
                            <div className="box6 flx a_center">
                                <span className="ft-Bold" style={{ marginRight: '6px' }}>&plusmn;</span>
                                <span className="fgr">{row.displayBaseValue.replace('± ', '').replace('분', '')}</span>
                                <span className="unit">분</span>
                            </div>
                            <div className="box10">
                                <span className="ft-Bold" style={{ marginRight: '6px' }}>&plusmn;</span>
                                <span className="fgr" style={{ ...colorStyle }}>{min}</span>
                                <span className="unit" style={{ marginRight: '10px' }}>분</span>
                                <span className="fgr" style={{ ...colorStyle }}>{sec}</span>
                                <span className="unit">초</span>
                            </div>
                        </>
                    );
                }

                if (row.calType === '검출율') {
                    const isGood = Number(row.displayValue) >= Number(row.displayBaseValue);
                    const colorStyle = { color: isGood ? 'var(--iv-05)' : 'var(--iv-02)' };
                    return (
                        <>
                            <div className="box7">
                                <span className="fgr">{row.displayBaseValue}</span>
                                <span className="unit">%</span>
                            </div>
                            <div className="box11">
                                <span className="fgr" style={{ ...colorStyle }}>{row.displayValue}</span>
                                <span className="unit">%</span>
                            </div>
                        </>
                    );
                }

                if (row.calType === '통신율') {
                    const isGood = Number(row.displayValue) >= Number(row.displayBaseValue);
                    const colorStyle = { color: isGood ? 'var(--iv-05)' : 'var(--iv-02)' };
                    return (
                        <>
                            <div className="box8">
                                <span className="fgr">{row.displayBaseValue}</span>
                                <span className="unit">%</span>
                            </div>
                            <div className="box12">
                                <span className="fgr"  style={{ ...colorStyle }}>{row.displayValue}</span>
                                <span className="unit">%</span>
                            </div>
                        </>
                    );
                }

                return null;
            })}

            <div className="box9">{month ? `${month}월 누적` : '누적'}</div>
        </div>
    );
}
